"use client"

import { useState } from "react"
import Header from "../GuestPage/Header/Header"
import Hero from "../GuestPage/Hero/Hero"
import Modal from "../GuestPage/Modal/Modal"
import ConnectSection from "../GuestPage/Connect-Section/ConnectSection"
import HowItWorks from "../GuestPage/how-It-Work/HowItWorks"
import WhyNetzSync from "../GuestPage/Why-netz-sync/WhyNetzSync"
import DemoForm from "../GuestPage/Demo-form/DemoForm"

function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleDemoClick = () => {
    setIsModalOpen(true)
  }

  const handleFormSubmit = (data) => {
    console.log("Form submitted:", data)
    alert("Demo request submitted successfully!")
    setIsModalOpen(false)
  }

  return (
    <div className="home-page">
      <Header onDemoClick={handleDemoClick} />
      <main>
        <Hero onDemoClick={handleDemoClick} />
        <ConnectSection />
        <HowItWorks />
        <WhyNetzSync />
      </main>
      {/* <Footer /> */}

      {/* Demo Modal */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <DemoForm onSubmit={handleFormSubmit} onClose={() => setIsModalOpen(false)} />
      </Modal>
    </div>
  )
}

export default HomePage
